import React from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";

export const PiplResultRecord = ({
  node,
  emailCount,
  socialProfileCount,
  // index,
}) => {
  // const noEmailBadge = (
  //   <Label size="tiny" basic color="grey">
  //     No email on file
  //   </Label>
  // );

  // const noSocialProfileBadge = (
  //   <Label size="tiny" basic color="grey">
  //     No social profile on file
  //   </Label>
  // );

  const addresses = _.get(
    node,
    "addresses[0].address",
    ""
  );

  // const city = _.get(
  //   node,
  //   "addresses[0].address[0].city[0]._",
  //   ""
  // );

  // const state = _.get(
  //   node,
  //   "addresses[0].address[0].state[0]._",
  //   ""
  // );

  // const address = city ? `${city}, ${state}` : state;

  // const thumbnailToken = _.get(
  //   node,
  //   "images[0].image[0].thumbnail_token[0]._"
  // );

  // const emailCountVal = _.get(
  //   node,
  //   "email_count[0]._"
  // );

  // const emailCount =
  //   emailCountVal && emailCountVal !== ""
  //     ? parseInt(emailCountVal, 10)
  //     : "NA";

  let countContent;

  if (!emailCount) {
    // if (
    //   socialProfileCount !== "NA" &&
    //   socialProfileCount > 0
    // ) {
      countContent = `Social Profile(s) Found: ${socialProfileCount}`;
    // } else {
    //   countContent = `Social Profile(s) Found: ${emailCount}`;
    // }
  // } else if (isEmailRecords && emailCount > 0) {
  //   countContent = `Email(s) Found: ${emailCount}`;
  } else {
    countContent = `Email(s) Found: ${emailCount}`;
  }

  return (
    <Table className="sub-table">
      <Table.Body>
        <Table.Row>
          <Table.Cell
            className="sub-table-cell text-bold"
            width={3}
          >
            DOB/Age:
            {_.get(
              node,
              "dob[0].display[0]._",
              "NA"
            )}
          </Table.Cell>

          <Table.Cell
            className="sub-table-cell text-bold"
            width={3}
          >
            Gender:
            {_.get(
              node,
              "gender[0].content[0]._",
              "NA"
            )}
          </Table.Cell>
          <Table.Cell
            className="sub-table-cell text-bold"
            width={3}
          >
            City/State:
            {addresses &&
                _.map(
                  _.uniq(
                    _.map(addresses, address => {
                      const city = _.get(address, "city[0]._");
                      const state = _.get(address, "state[0]._");

                      return city && state
                        ? `${city}, ${state}`
                        : city || state;
                    })
                  ),
                  (location, index) => (
                    <div key={`address_${index}`}>
                      {location}
                    </div>
                  )
                )
                // _.map(
                //   _.uniq(
                //     _.filter(
                //       _.map(addresses, address => {
                //         const city = _.get(address, "city[0]._");
                //         const state = _.get(address, "state[0]._");

                //         return city && state
                //           ? `${city}, ${state}`
                //           : city || state;
                //       }),
                //       value => value
                //     )
                //   ),
                //   (location, index) => (
                //     <div key={`address_${index}`}>
                //       {location}
                //     </div>
                //   )
                // )
              }
          </Table.Cell>
          <Table.Cell
            // colSpan={2}
            className="sub-table-cell text-bold"
            width={3}
          >
            {countContent}
          </Table.Cell>
          {/* <Table.Cell
            rowSpan={2}
            className="sub-table-cell text-bold"
            width={2}
          >
            Photo:
          </Table.Cell>

          <Table.Cell
            rowSpan={2}
            className="sub-table-cell"
            width={3}
          >
            {thumbnailToken ? (
              <Image
                inline
                size="tiny"
                src={`http://thumb.pipl.com/image?height=250&width=250&favicon=true&zoom_face=true&tokens=${thumbnailToken}`}
                centered
              />
            ) : (
              "NA"
            )}
          </Table.Cell> */}
        </Table.Row>

        {/* <Table.Row className="table-no-border">
          <Table.Cell
            className="sub-table-cell text-bold"
            width={4}
          >
            City/State:
            {address}
          </Table.Cell>

          <Table.Cell
            colSpan={2}
            className="sub-table-cell text-bold"
            width={6}
          >
            {countContent}
          </Table.Cell>
        </Table.Row> */}
      </Table.Body>
    </Table>
  );
};

export default PiplResultRecord;


// WEBPACK FOOTER //
// ./src/components/searchresults/PiplResultRecord.js